export default function LogOutIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      id="Regular"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M31.9 32.35q-.6-.6-.6-1.425 0-.825.6-1.375L35.45 26h-15.1q-.8 0-1.375-.575T18.4 24q0-.85.575-1.425Q19.55 22 20.35 22h15l-3.6-3.6q-.55-.5-.55-1.325t.6-1.425q.6-.55 1.45-.55t1.4.6l7 6.95q.3.3.425.675.125.375.125.725 0 .4-.125.75t-.425.65L34.7 32.4q-.55.5-1.35.5t-1.45-.55ZM8.95 42.7q-1.6 0-2.775-1.175Q5 40.35 5 38.75V9.25Q5 7.6 6.175 6.425 7.35 5.25 8.95 5.25h12.8q.8 0 1.375.6T23.7 7.3q0 .8-.575 1.375t-1.375.575H8.95v29.5h12.8q.8 0 1.375.575t.575 1.425q0 .8-.575 1.375t-1.375.575Z"
      />
      {/* <g
        transform="matrix(2,0,0,2,0,0)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <line x1="0.75" y1="12.004" x2="16.5" y2="12.004"></line>
        <polyline points="12.75 15.754 16.5 12.004 12.75 8.254"></polyline>
        <path d="M3.306,16.6a10.5,10.5,0,1,0,.179-9.542"></path>
      </g> */}
    </svg>
  );
}
